/**
 * Release flags. Production values live here and change only by an approved release.
 *
 * PROFILE_HUB_LAYOUT — the public Athlete Business Hub layout
 * (Hero → Know Her → Follow Her → Back Her → Work With Her → Related).
 * OFF in production. A verified admin can preview it per page with
 * `?adminPreview=1&layout=hub`; nobody else can opt in.
 */
export const PROFILE_HUB_LAYOUT = false;

export const useHubLayoutFor = (opts: { previewMode: boolean; layoutParam: string | null }) =>
  PROFILE_HUB_LAYOUT || (opts.previewMode && opts.layoutParam === "hub");

/**
 * Profile review pilot — athletes allowed to see the new review/approval controls
 * (approve current live profile, or review a SIIS draft) and to have an admin draft editor.
 * Code-reviewed allowlist of permanent athlete IDs. Presentation only: the database still
 * enforces ownership, admin-only launch, consent and fingerprint checks for everyone.
 */
export const PROFILE_REVIEW_PILOT_IDS: readonly string[] = [
  "8b6fca8d-ad3e-4779-b53b-e57b64d58e62", // Nicole Muccio
];
export const isReviewPilot = (athleteId: string | null | undefined) =>
  Boolean(athleteId) && PROFILE_REVIEW_PILOT_IDS.includes(athleteId as string);

/**
 * First-party analytics (Phase 1 infrastructure only). Browser tracking is ON only for the
 * pilot allowlist below (approved Oct 2026). An empty list would mean site-wide — never empty it
 * without an approved release. When enabled with a non-empty
 * pilot list, only those athletes' profiles send events (validation phase).
 */
export const ANALYTICS_TRACKING_ENABLED = true;
export const ANALYTICS_PILOT_ATHLETE_IDS: readonly string[] = [
  "8b6fca8d-ad3e-4779-b53b-e57b64d58e62", // Nicole Muccio — classic-profile baseline before her Hub launch
];
